import { FC } from 'react'
import styled from 'styled-components'

import { ImageSize, ImageStyle } from '@/constants/tools/ai-image-generator'

import { TopicArea } from './TopicArea'
import { OptionsArea } from './OptionsArea'
import { ResultArea } from './ResultArea'
import { ExportArea } from './ExportArea'

type GeneratorFormProps = {
  /**
   * 토픽 입력란
   */
  topic?: string
  onChangeTopic?: (topic: string) => void
  disabledChangeTopic?: boolean

  onGenerate?: () => void
  disabledGenerate?: boolean

  /**
   * 옵션 입력란
   */
  imageStyle?: ImageStyle
  onChangeImageStyle?: (imageStyle: ImageStyle) => void

  imageSize?: ImageSize
  onChangeImageSize?: (imageSize: ImageSize) => void

  disabledChangeOptions?: boolean

  /**
   * 결과 표시란
   */
  imageSrc?: string
  /**
   * 1 ~ 100
   */
  progress?: number

  isGenerated?: boolean
  isGenerating?: boolean
  isError?: boolean

  /**
   * 내보내기 영역
   */
  onDownload?: () => void
  onCreateVideo?: () => void

  disabledExport?: boolean

  /**
   * 유저 정보를 가져오는 중인지 여부
   */
  isLoadingUserInfo?: boolean
  /**
   * 로그인 여부
   */
  isLoggedIn?: boolean
  /**
   * 유료 사용자 여부
   */
  isPaidUser?: boolean
  /**
   * 남은 무료 제공 횟수
   */
  remainingFreeTrialCount?: number

  className?: string
}

export const GeneratorForm: FC<GeneratorFormProps> = ({
  topic,
  onChangeTopic,
  disabledChangeTopic,

  onGenerate,
  disabledGenerate,

  imageStyle,
  onChangeImageStyle,

  imageSize,
  onChangeImageSize,

  disabledChangeOptions,

  imageSrc,
  progress,

  isGenerated,
  isGenerating,
  isError,

  onDownload,
  onCreateVideo,

  disabledExport,

  isLoadingUserInfo,
  isLoggedIn,
  isPaidUser,
  remainingFreeTrialCount,

  className,
}) => {
  return (
    <GeneratorFormContainer className={className}>
      <GeneratorFormFlexContainer>
        <GeneratorFormFlexItem>
          {/* 
            토픽 입력 영역
          */}
          <TopicArea
            topic={topic}
            onChangeTopic={onChangeTopic}
            disabledChangeTopic={disabledChangeTopic}
            onGenerate={onGenerate}
            disabledGenerate={disabledGenerate}
            isError={isError}
            isLoadingUserInfo={isLoadingUserInfo}
            isLoggedIn={isLoggedIn}
            isPaidUser={isPaidUser}
            remainingFreeTrialCount={remainingFreeTrialCount}
          />

          {/* 
            옵션 선택 영역
          */}
          <OptionsArea
            imageStyle={imageStyle}
            onChangeImageStyle={onChangeImageStyle}
            imageSize={imageSize}
            onChangeImageSize={onChangeImageSize}
            disabled={disabledChangeOptions}
          />
        </GeneratorFormFlexItem>

        <GeneratorFormFlexItem>
          {/* 
            결과 미리보기 및 진행률 영역
          */}
          <ResultArea
            imageSrc={imageSrc}
            progress={progress}
            isGenerated={isGenerated}
            isGenerating={isGenerating}
          />

          {/* 
            다운로드 및 비디오 생성 버튼 영역\
            다른 제너레이터로 전환 링크
          */}
          {isGenerated && (
            <ExportArea
              onDownload={onDownload}
              onCreateVideo={onCreateVideo}
              disabled={disabledExport}
            />
          )}
        </GeneratorFormFlexItem>
      </GeneratorFormFlexContainer>
    </GeneratorFormContainer>
  )
}

const GeneratorFormContainer = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;

  padding: 20px 40px 10px 40px;

  @media (max-width: ${({ theme }) => theme.screenLG}px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`

const GeneratorFormFlexContainer = styled.div`
  display: flex;
  column-gap: 50px;
  /* display: flex;
  grid-template-columns: 1fr 1fr;
  column-gap: 50px; */

  @media (max-width: ${({ theme }) => theme.screenMD}px) {
    /* grid-template-columns: 1fr; */
    flex-direction: column;
  }
`

const GeneratorFormFlexItem = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
`
